(function () {
  const config = window.CeroLocalCurrencyConfig || {};
  const country = String(config.country || '').toUpperCase();
  const countryCurrencies = {
    AR: 'ARS', AU: 'AUD', BO: 'BOB', BR: 'BRL', CA: 'CAD', CH: 'CHF',
    CL: 'CLP', CO: 'COP', DK: 'DKK', GB: 'GBP', IL: 'ILS', IN: 'INR',
    JP: 'JPY', KR: 'KRW', MX: 'MXN', NO: 'NOK', NZ: 'NZD', PE: 'PEN',
    PY: 'PYG', SE: 'SEK', UY: 'UYU', ZA: 'ZAR'
  };
  const euroCountries = ['AT', 'BE', 'CY', 'DE', 'EE', 'ES', 'FI', 'FR', 'GR', 'HR', 'IE', 'IT', 'LT', 'LU', 'LV', 'MT', 'NL', 'PT', 'SI', 'SK'];
  const currency = euroCountries.includes(country) ? 'EUR' : countryCurrencies[country];
  const fallbackRates = {
    ARS: 1513.6838, AUD: 1.406391, BOB: 11.049445, BRL: 5.112197,
    CAD: 1.405443, CHF: 0.820768, CLP: 947.822364, COP: 3200.183068,
    DKK: 6.521312, EUR: 0.873207, GBP: 0.749328, ILS: 3.009744,
    INR: 95.647843, JPY: 157.415417, KRW: 1353.703547, MXN: 17.283601,
    NOK: 9.438475, NZD: 1.746729, PEN: 3.371378, PYG: 5934.618438,
    SEK: 9.830772, UYU: 40.227866, ZAR: 16.209564
  };

  if (!currency || currency === 'USD') return;

  const selectors = '.price, .product-price, .cart-total, .outfit-total strong, [data-local-price]';
  const cacheKey = 'cero_usd_exchange_rates_v1';
  const cacheDuration = 12 * 60 * 60 * 1000;
  let rate = Number(fallbackRates[currency]) || null;
  let renderTimer = null;

  function parseUsd(text) {
    const match = String(text || '').match(/US\$\s*([0-9][0-9.,]*)/i);
    if (!match) return null;
    const normalized = match[1].replace(/,/g, '');
    const value = Number(normalized);
    return Number.isFinite(value) ? value : null;
  }

  function formatLocal(value) {
    return new Intl.NumberFormat(config.locale || undefined, {
      style: 'currency',
      currency: currency,
      maximumFractionDigits: ['COP', 'CLP', 'PYG', 'KRW', 'JPY'].includes(currency) ? 0 : 2
    }).format(value * rate);
  }

  function label(value) {
    const formatted = formatLocal(value);
    if (config.language === 'es') return 'Aprox. ' + formatted;
    if (config.language === 'pt' || config.language === 'pt-BR') return 'Aprox. ' + formatted;
    return 'Approx. ' + formatted;
  }

  function renderPrices() {
    if (!rate) return;
    document.querySelectorAll(selectors).forEach(function (element) {
      if (element.matches('.price') && element.querySelector('.price')) return;
      const ownClone = element.cloneNode(true);
      ownClone.querySelectorAll('.cero-local-price').forEach(function (node) { node.remove(); });
      const usdValue = parseUsd(ownClone.textContent);
      const existing = element.querySelector(':scope > .cero-local-price');
      if (usdValue === null) {
        if (existing) existing.remove();
        return;
      }
      const localPrice = existing || document.createElement('small');
      localPrice.className = 'cero-local-price';
      localPrice.textContent = label(usdValue);
      localPrice.setAttribute('aria-label', localPrice.textContent + '. Final checkout is charged in US dollars.');
      if (!existing) element.appendChild(localPrice);
    });
  }

  function scheduleRender() {
    window.clearTimeout(renderTimer);
    renderTimer = window.setTimeout(renderPrices, 80);
  }

  function readCache() {
    try {
      const cached = JSON.parse(window.localStorage.getItem(cacheKey) || 'null');
      if (cached && Date.now() - cached.savedAt < cacheDuration && cached.rates) return cached.rates;
    } catch (error) {
      return null;
    }
    return null;
  }

  function saveCache(rates) {
    try {
      window.localStorage.setItem(cacheKey, JSON.stringify({ savedAt: Date.now(), rates: rates }));
    } catch (error) {
      return;
    }
  }

  async function loadRate() {
    const cachedRates = readCache();
    if (cachedRates && cachedRates[currency]) {
      rate = Number(cachedRates[currency]);
      renderPrices();
    } else if (rate) {
      renderPrices();
    }
    try {
      const response = await fetch('https://open.er-api.com/v6/latest/USD', { mode: 'cors', credentials: 'omit' });
      if (!response.ok) throw new Error('Exchange rate unavailable');
      const payload = await response.json();
      if (!payload.rates || !payload.rates[currency]) throw new Error('Currency unavailable');
      saveCache(payload.rates);
      rate = Number(payload.rates[currency]);
      renderPrices();
    } catch (error) {
      if (!rate) document.documentElement.classList.add('cero-local-currency-unavailable');
    }
  }

  new MutationObserver(scheduleRender).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  loadRate();
}());
